<div class="date-container">
    <div class="month-container">
        {{ month | uppercase }}
    </div>
    <div class="day-container">
        {{ day }}
    </div>
    <div class="detail-container">
        {{ detail | uppercase }}
    </div>
</div>